import React from 'react';
import { Link } from 'react-router-dom';
import MarketingLayout from '../components/marketing/MarketingLayout';
import { SUCCESS_STORIES, BRAND } from '../data/siteContent';
import studentSmile from '../assets/images/student-smile.png';

export default function SuccessStoriesPage() {
  return (
    <MarketingLayout>
      <header className="mk-page-hero">
        <div className="mk-container">
          <div className="mk-page-hero-grid">
            <div>
              <span className="mk-eyebrow">Success Stories</span>
              <h1>Students who crossed the bridge</h1>
              <p>
                Real preparation journeys with {BRAND.name} - structured plans, AI practice, and
                first-attempt confidence.
              </p>
            </div>
            <div className="mk-page-photo-card mk-page-photo-light">
              <img src={studentSmile} alt="Successful student smiling after reaching a study goal" />
              <div className="mk-page-photo-badge">
                <strong>Confident outcomes</strong>
                <small>Support that feels personal</small>
              </div>
            </div>
          </div>
        </div>
      </header>

      <section className="mk-section">
        <div className="mk-container">
          <div className="mk-story-grid mk-story-grid-lg">
            {SUCCESS_STORIES.map((t) => (
              <blockquote key={t.name} className="mk-story-card">
                <span className="mk-story-focus">{t.focus}</span>
                <p>“{t.quote}”</p>
                <footer>
                  <span className="mk-avatar">{t.initials}</span>
                  <div>
                    <strong>{t.name}</strong>
                    <small>{t.role}</small>
                  </div>
                </footer>
              </blockquote>
            ))}
          </div>
          <div className="mk-center-cta">
            <Link to="/signup" className="mk-btn mk-btn-primary mk-btn-lg">
              Start your story
            </Link>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
